import type { RouteLocationNormalized } from 'vue-router';
import { i18n } from '@/i18n';
import { getLoginWithRedirect } from '@/router/getLoginWithRedirect';
import { useAuthStore } from '@/stores/auth';
import { useUserStore } from '@/stores/user';
import { displayError } from '@/utils/displayError';

export const changeEmail = async (to: RouteLocationNormalized) => {
  const userStore = useUserStore();
  const verificationId = to.query['verification-request-id'] as string;

  try {
    await userStore.changeEmailVerify(verificationId);
    userStore.user = undefined;
    return { name: 'security', query: { emailChanged: 'true' } };
  } catch (error: any) {
    const statusCode = error.response?.status;
    if (statusCode === 401) {
      useAuthStore().setIsAuthorized(false);
      return getLoginWithRedirect(to);
    }
    if (statusCode === 400) {
      displayError([i18n.global.t('emailChangeLinkIsNotValid')]);
    }
    return { name: 'root' };
  }
};
